/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */

import { isObject } from '../../domain/utils/utilitarios-frontend-coopeuch/object';
import { isArray } from '../../domain/utils/utilitarios-frontend-coopeuch/array';

// ✅ FUNCIONES AUXILIARES - Reducen complejidad cognitiva

const convertKeyToStorageName = (key) => {
  return key
    .split(/(?=[A-Z])/)
    .join('-')
    .toLowerCase();
};

const parseStorageValue = (storageValue, originalValue) => {
  if (typeof originalValue === 'boolean') {
    return storageValue === 'true';
  }
  return storageValue;
};

const saveObjectToStorage = (value, nameProp) => {
  for (const [littleKey, littleVal] of Object.entries(value)) {
    sessionStorage.setItem(`${littleKey}-${nameProp}`, littleVal);
  }
};

const savePrimitiveToStorage = (value, nameProp) => {
  sessionStorage.setItem(nameProp, value);
};

const loadObjectFromStorage = (valueObj, nameProp) => {
  const result = {};
  for (const [littleKey, littleValue] of Object.entries(valueObj)) {
    const valueStorage = sessionStorage.getItem(`${littleKey}-${nameProp}`);
    result[littleKey] = parseStorageValue(valueStorage, littleValue);
  }
  return result;
};

const loadPrimitiveFromStorage = (value, nameProp) => {
  /* istanbul ignore next */
  const valueStorage = sessionStorage.getItem(nameProp);
  /* istanbul ignore next */
  return parseStorageValue(valueStorage, value);
};

const getValueFromStorage = (value, nameProp) => {
  if (isObject(value.value)) {
    if (!isArray(value.value)) {
      return loadObjectFromStorage(value.value, nameProp);
    }
    // TODO: pendiente aplicar metodo para convertir array guardado en storage y devolverlo a array
    /* istanbul ignore next */
    return [];
  }
  
  return loadPrimitiveFromStorage(value.value, nameProp);
};

// ✅ FUNCIONES PRINCIPALES SIMPLIFICADAS

export const saveAllEntitiesToStorage = (entitiesObject, arrayIgnoredEntities = []) => {
  for (const [key, value] of Object.entries(entitiesObject)) {
    if (arrayIgnoredEntities.includes(key)) {
      continue;
    }

    const nameProp = convertKeyToStorageName(key);
    
    if (isObject(value.value)) {
      saveObjectToStorage(value.value, nameProp);
    } else {
      savePrimitiveToStorage(value.value, nameProp);
    }
  }
};

export const saveAllEntitiesFromStorage = (entitiesObject, arrayIgnoredEntities = []) => {
  const arrayObjectKeysValues = [];
  
  for (const [key, value] of Object.entries(entitiesObject)) {
    if (arrayIgnoredEntities.includes(key)) {
      continue;
    }

    const nameProp = convertKeyToStorageName(key);
    const tempValue = getValueFromStorage(value, nameProp);
    
    arrayObjectKeysValues.push({ key, value: tempValue });
  }
  
  return arrayObjectKeysValues;
};